import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loggedInUser: null,
  loginInProgress: false,
  fetchingUser: false,
  error: null,
  message: null,
  resetPasswordStatus: null,
  fetchingLoggedInUser: true,
  logoutInProgress: false,
  logoutSuccess: false,
  ssoUser: null,
  isSSOAuthenticated: false,
  isKeycloakReady: false,
  authFlow: null,
  ssoUserFetchCompleted: false,
  ssoLogoutInProgress: false,
  // Onboarding state
  redirectPayload: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.loginInProgress = true;
      state.logoutSuccess = false;
      state.error = null;
    },
    loginSuccess(state, action) {
      state.loginInProgress = false;
      state.error = null;
    },
    loginFailure(state, action) {
      state.error =
        "An error occured during login. Please check username/password or try again later.";
      state.loginInProgress = false;
    },
    fetchLoggedInUser(state, action) {
      state.fetchingLoggedInUser = true;
      state.loggedInUser = null;
    },
    fetchLoggedInUserSuccess(state, action) {
      state.fetchingLoggedInUser = false;
      state.loggedInUser = action.payload.data.document;
      state.ssoUserFetchCompleted = true;
    },
    fetchLoggedInUserFailure(state, action) {
      state.fetchingLoggedInUser = false;
      state.loggedInUser = null;
      state.ssoUserFetchCompleted = true;
    },
    logout(state, action) {
      state.logoutInProgress = true;
      state.logoutSuccess = false;
      state.error = null;
    },
    logoutSuccess(state, action) {
      state.logoutInProgress = false;
      state.logoutSuccess = true;
      state.error = null;
    },
    logoutFailure(state, action) {
      state.error = action.payload?.message || "Logout failed";
      state.logoutInProgress = false;
      state.logoutSuccess = false;
    },
    setSSOUser(state, action) {
      state.ssoUser = action.payload;
      state.isSSOAuthenticated = true;
      state.loggedInUser = action.payload;
      state.fetchingLoggedInUser = false;
    },
    clearSSOUser(state) {
      state.ssoUser = null;
      state.isSSOAuthenticated = false;
      state.loggedInUser = null;
      state.ssoUserFetchCompleted = false;
    },
    setKeycloakReady(state, action) {
      state.isKeycloakReady = action.payload;
    },
    setAuthFlow(state, action) {
      state.authFlow = action.payload;
    },
    setSSOLogoutInProgress(state, action) {
      state.ssoLogoutInProgress = action.payload;
    },
    // Onboarding reducers
    triggerOnboardingRedirect(state, action) {
      state.redirectPayload = action.payload;
      state.fetchingLoggedInUser = false;
      state.ssoUserFetchCompleted = true;
    },
    clearOnboardingRedirect(state) {
      state.redirectPayload = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = authSlice;
export const { triggerOnboardingRedirect, clearOnboardingRedirect } = actions;
